const AddAQuestion = (state = '', action) => {
    switch (action.type) {
        case 'USER_ASK_QUESTION_SUCCESS':
            return action.payload.res.data.Question
        default:
            return state
    }
}
export default AddAQuestion